export const useSmoothScroll = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
     
      const header = document.querySelector('header');
      const headerHeight = header?.offsetHeight || 0;
      
      const elementPosition = element.offsetTop - headerHeight - 20; 
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return { scrollToSection };
}; 